<template>
  <div class="filters">
    <div class="filter">

      <div v-if="showPeriod" class="filter_item">
        <div class="wrap_titler">
          <div class="titler">Период</div>
          <div v-if="hasDate" class="clear" @click="clearDate">
            <Icon name="close"/>
          </div>
        </div>

        <v-menu v-model="menuDate" :close-on-content-click="false" offset-y min-width="auto">
          <template #activator="{ on, attrs }">
            <div class="rel" v-bind="attrs" v-on="on">
              <v-text-field v-model="rangeText" readonly class="input_custom input_range"
                            dense hide-details height="40"/>
              <Icon class="abs" name="calendar"/>
            </div>
          </template>

          <v-card class="pa-2 picker-card">
            <v-date-picker v-model="dateRange" locale="ru" range color="#4B5EFF"
                           header-color="white" light :first-day-of-week="1"
                           :show-current="true" class="picker-fix" @change="saveDate"/>
            <div class="d-flex mt-2" v-if="!hideTime">
              <v-text-field v-model="filters.startTime" type="time" dense hide-details
                            class="mr-2 time-field"/>
              <v-text-field v-model="filters.endTime"   type="time" dense hide-details
                            class="time-field"/>
            </div>
            <v-btn block class="ok-btn mt-2" @click="saveDate">OK</v-btn>
          </v-card>
        </v-menu>
      </div>

      <template v-if="filterConfig && filterConfig.length">
        <div class="filter_item" v-for="cfg in filterConfig" :key="cfg.field">
<template v-if="cfg.type==='select'">
  <div class="wrap_titler">
    <div class="titler">{{ cfg.label }}</div>
    <div
      v-if="cfg.multiple ? (filters[cfg.field] && filters[cfg.field].length) : filters[cfg.field]"
      class="clear"
      @click="filters[cfg.field] = cfg.multiple ? [] : null"
    >
      <Icon name="close"/>
    </div>
  </div>
  <v-combobox
    v-model="filters[cfg.field]"
    :items="selects[cfg.items] || []"
    item-text="name"
    item-value="id"
    :multiple="cfg.multiple === true"
    :chips="false"
    dense
    hide-details
    clearable
    placeholder="Выберите"
    clear-icon=""
    class="input_custom input_custom--select"
  >
  <template v-if="cfg.multiple" v-slot:selection="{ index }">
    <span v-if="index === 0">
      <span v-if="Array.isArray(filters[cfg.field]) && filters[cfg.field].length">
        Выбранно {{ filters[cfg.field].length }}
      </span>
    </span>
  </template>
  </v-combobox>
</template>


<template v-else-if="cfg.type==='range'">
 <div class="wrap_titler center"><div class="titler">{{ cfg.label }}</div></div>
 <div class="d-flex align-end range-row">
    <div class="mr-2">
      <div class="titler mb-1">от</div>
      <v-text-field v-model="filters[`${cfg.field}_from`]" type="number"
                    dense hide-details class="input_custom"/>
    </div>
    <div>
      <div class="titler mb-1">до</div>
      <v-text-field v-model="filters[`${cfg.field}_to`]"   type="number"
                    dense hide-details class="input_custom"/>
    </div>
  </div>
</template>

          <template v-else-if="cfg.type==='search'">
            <div class="wrap_titler"><div class="titler">{{ cfg.label }}</div></div>
            <v-text-field v-model="filters[cfg.field]" dense hide-details
                          placeholder="Введите значение" class="input_custom"/>
          </template>
        </div>
      </template>

      <template v-else>
        <div v-if="page_type === 'bases_main'" class="filter_item">
          <div class="wrap_titler">
            <div class="titler">Название базы</div>
            <div
              v-if="filters.baseNames && filters.baseNames.length"
              class="clear"
              @click="filters.baseNames = []"
            >
              <Icon name="close" />
            </div>
          </div        >
        
           <v-combobox
            v-model="filters.baseNames"
            :items="selects.baseNames || []"
            multiple
            dense
            hide-details
            clearable
            :chips="false"
            :deletable-chips="false"
            placeholder="Выберите базу"
            clear-icon=""
            class="input_custom input_custom--base-names"
          >
            <template v-slot:selection="{ index }">
              <span v-if="index === 0">
                Выбрано {{ Array.isArray(filters.baseNames) ? filters.baseNames.length : 0 }}
              </span>
            </template>
          </v-combobox>
        </div>
        <div v-if="showScript"  class="filter_item">
          <div class="wrap_titler">
            <div class="titler">Скрипт обзвона</div>
            <div v-if="filters.script" class="clear" @click="filters.script=null"><Icon name="close"/></div>
          </div>
          <v-combobox v-model="filters.script" :items="selects.scripts || []"
                      item-text="name" item-value="id" dense hide-details
                      clearable placeholder="Выберите" class="input_custom"/>
        </div>
        <div v-if="page_type === 'bases_main'" class="filter_item">
          <div class="wrap_titler">
            <div class="titler">ID базы</div>
            <div
              v-if="filters.baseGuids && filters.baseGuids.length"
              class="clear"
              @click="filters.baseGuids = []"
            >
              <Icon name="close" />
            </div>
          </div>
        
          <v-autocomplete
            v-model="filters.baseGuids"
            :items="selects.bases || []"
            item-text="guid"
            item-value="guid"
            multiple
            dense
            hide-details
            clearable
            :chips="false"
            :deletable-chips="false"
            placeholder="Выберите ID базы"
            clear-icon=""
            class="input_custom input_custom--base-guids"
          >
            <template v-slot:selection="{ index }">
              <span v-if="index === 0">
                Выбрано {{ Array.isArray(filters.baseGuids) ? filters.baseGuids.length : 0 }}
              </span>
            </template>
          </v-autocomplete>
        </div>

        <!-- Источник -->
        <div v-if="showSource" class="filter_item">
          <div class="wrap_titler">
            <div class="titler">Источник</div>
            <div v-if="filters.source" class="clear" @click="filters.source=null"><Icon name="close"/></div>
          </div>
          <v-combobox v-model="filters.source" :items="selects.sources || []"
                      item-text="name" item-value="id" dense hide-details
                      clearable placeholder="Выберите" class="input_custom"/>
        </div>

        <!-- Обзвон -->
        <div v-if="showCall" class="filter_item">
          <div class="wrap_titler">
            <div class="titler">Обзвон</div>
            <div v-if="filters.call" class="clear" @click="filters.call=null"><Icon name="close"/></div>
          </div>
          <v-combobox v-model="filters.call" :items="selects.calls || []"
                      :item-text="itemLabel" :item-value="itemLabel"
                      dense hide-details clearable placeholder="Выберите"
                      class="input_custom"/>
        </div>

        <!-- База -->
        <div v-if="showBase" class="filter_item">
          <div class="wrap_titler">
            <div class="titler">База номеров</div>
            <div v-if="filters.base" class="clear" @click="filters.base=null"><Icon name="close"/></div>
          </div>
          <v-combobox v-model="filters.base" :items="selects.bases || []"
                      :item-text="itemLabel" :item-value="itemLabel"
                      dense hide-details clearable placeholder="Выберите"
                      class="input_custom"/>
        </div>
      </template>
    </div>

    <div class="filter">
      <div v-if="['reports','incoming_targets'].includes(page_type)" class="filter_item ml-4">
        <div class="only-successful-with-tip">
          <v-checkbox v-model="filters.only_successful"  color="#4B5EFF" dense hide-details label="Только успешные"/>
          <v-tooltip bottom>
            <template #activator="{on,attrs}">
              <v-icon small v-bind="attrs" v-on="on" class="tip-icon">mdi-help-circle-outline</v-icon>
            </template>
            <span>Цели, отмеченные «Успешный звонок»</span>
          </v-tooltip>
        </div>
      </div>

      <!-- кнопки -->
      <div class="filter_item ml-4">
        <div
          v-if="cooldownSeconds > 0"
          class="apply-timer"
        >
          Повторно через {{ cooldownSeconds }} сек.
        </div>
        <v-btn class="apply-btn ml-4" height="40" :disabled="applyDisabled" @click="emitFilters">Применить</v-btn>
      </div>
      <div class="filter_item ml-2" v-if="!hideExport">
        <v-btn class="export-btn ml-2" height="40" @click="handleExport">Экспорт</v-btn>
      </div>
    </div>

    <!-- диалог группировки для экспорта (без изменений) -->
    <v-dialog
      v-if="!hideExport"
      v-model="dialogGroup"
      max-width="480"
      content-class="export-group-dialog"
    >
      <v-card class="export-dialog-card">
        <div class="export-dialog-head">
          <!-- <div class="export-dialog-icon">
            <Icon name="download"/>
          </div> -->
    
          <div>
            <h2 class="export-dialog-title">Выгрузка данных</h2>
    
            <p class="export-dialog-subtitle">
              Выберите формат будущего файла
            </p>
          </div>
        </div>
    
        <v-radio-group
          v-model="grouping"
          class="export-options"
          column
          mandatory
          hide-details
        >
          <v-radio
            class="export-option"
            value="none"
            color="#4B5EFF"
          >
            <template #label>
              <div class="export-option-content">
                <div class="export-option-title">
                  Обычная выгрузка
                </div>
    
              <div class="export-option-description"> {{ page_type === 'ops_history' ? 'Одна строка на каждую операцию' : 'Выгрузка без дополнительной группировки' }} </div>
              </div>
            </template>
          </v-radio>
    
          <v-radio
            v-if="page_type === 'ops_history'"
            class="export-option"
            value="trunk"
            color="#4B5EFF"
          >
            <template #label>
              <div class="export-option-content">
                <div class="export-option-title">
                  Группировка по транку
                </div>
    
                <div class="export-option-description">
                  Операция разделится на строки по каждому транку
                </div>
              </div>
            </template>
          </v-radio>
    
          <v-radio
            v-else
            class="export-option"
            value="source"
            color="#4B5EFF"
          >
            <template #label>
              <div class="export-option-content">
                <div class="export-option-title">
                  Группировка по источнику
                </div>
    
                <div class="export-option-description">
                  Данные будут разделены по источникам
                </div>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
    
        <div class="export-dialog-actions">
          <v-btn
            text
            class="export-cancel-btn"
            @click="dialogGroup = false"
          >
            Отмена
          </v-btn>
    
          <v-btn
            class="export-confirm-btn"
            elevation="0"
            @click="confirmExport"
          >
            Выгрузить
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Icon from '../SetIcon.vue'

export default {
  name: 'ReportsFilter',
  components: { Icon },

  props: {
    page_type:     { type:String, required:true },
    selects:       { type:Object,  default:()=>({}) },
    callback:      { type:Function,default:null   },
    filterConfig:  { type:Array,   default:()=>[] },
    showPeriod:   { type:Boolean, default: true },
    hideExport:{ type:Boolean, default:false },
    hideTime:      { type:Boolean, default:false },
    rangePlaceholder:  { type:String,  default:'За сегодня' },
    applyDisabled: { type: Boolean, default: false },
    cooldownSeconds: { type: Number, default: 0 },
  },

data () {
  const baseFilters = {
    script:null, source:null, call:null, base:null, baseNames: [],baseGuids:[],
    only_successful:false,
    startDate:null, startTime:'00:00',
    endDate:null,   endTime:'23:59'
  }

  if (this.filterConfig && this.filterConfig.length) {
    this.filterConfig.forEach(c => {
      if (c.type === 'range') {
        baseFilters[`${c.field}_from`] = null
        baseFilters[`${c.field}_to`]   = null
      } else if (c.type === 'select' && c.multiple) {
        baseFilters[c.field] = []
      } else {
        baseFilters[c.field] = null
      }
    })
  }

  return {
    menuDate:false,
    dateRange:[],
    dialogGroup:false,
    grouping:'none',
    filters:baseFilters
  }
},

  computed:{
    showScript(){ return !this.filterConfig.length && ['reports','sources','bases'].includes(this.page_type) },
    showSource(){ return !this.filterConfig.length && ['reports','scripts','bases'].includes(this.page_type) },
    showCall()  { return !this.filterConfig.length && ['reports','scripts','sources','bases'].includes(this.page_type) },
    showBase()  { return !this.filterConfig.length && ['reports','scripts','sources'].includes(this.page_type) },

    hasDate(){ return !!(this.filters.startDate && this.filters.endDate) },

    rangeText(){
      if(!this.filters.startDate||!this.filters.endDate) return this.rangePlaceholder
      const fmtDate = (d) => {
      const [y, m, day] = d.split('-')
      return `${day}.${m}.${y}`
     }
     if (this.hideTime) {
     return `${fmtDate(this.filters.startDate)} – ${fmtDate(this.filters.endDate)}`
     }
      const fmt=(d,t)=>{const[y,m,day]=d.split('-');return`${day}.${m}.${y} ${t}:00`}
      return `${fmt(this.filters.startDate,this.filters.startTime)} – ${fmt(this.filters.endDate,this.filters.endTime)}`
    }
  },

  watch: {
    filters: {
      deep: true,
      handler(value) {
        this.$emit('filterChanged', { ...value })
      }
    }
  },

  created(){
    this.$set(this.$vuetify.lang.locales.en.datePicker,'itemsSelected','{0} выбрано')
    this.$set(this.$vuetify.lang.locales.ru.datePicker,'itemsSelected','{0} выбрано')
    this.$vuetify.lang.current='ru'
  },

  mounted() {
  this.$emit('filterChanged', { ...this.filters })
 },

  methods:{
    itemLabel(item){
      return typeof item==='object' && item
        ? item.name||item.label||item.value||item.id
        : String(item)
    },

    saveDate(){
      if(this.dateRange?.length===2){
        [this.filters.startDate,this.filters.endDate]=this.dateRange
      }else{
        this.filters.startDate=this.filters.endDate=null
      }
      this.menuDate=false
    },
    clearDate(){ this.dateRange=[]; this.filters.startDate=this.filters.endDate=null },


    emitFilters(){
      const payload={...this.filters}
      this.callback?.(payload)
      this.$emit('updateFilter',payload)
    },


    handleExport(){
      if(['reports','scripts','bases', 'ops_history'].includes(this.page_type)){
        this.dialogGroup=true
      }else{ this.sendExport('none') }
    },
    confirmExport(){ this.dialogGroup=false; this.sendExport(this.grouping) },
    sendExport (grouping) {
      const payload = {
        ...this.filters,
        group_by: grouping === 'source' ? 'source' : null
      }
    
      if (this.page_type === 'ops_history') {
        payload.group_by_trunk = grouping === 'trunk'
      }
    
      this.$emit('export', payload)
    }
  }
}
</script>

<style scoped>
::v-deep .input_custom--base-names .v-input__slot {
  min-height: 40px;
  max-height: 40px;
  min-width: 210px;
  max-width: 210px;
}
::v-deep .input_custom--base-guids .v-input__slot {
  min-height: 40px;
  max-height: 40px;
  min-width: 210px;
  max-width: 210px;
}
/* ────────────────────  DATE-PICKER  ──────────────────── */
/* ---- Календарь внутри .picker-card ---- */
::v-deep(.picker-card){

  /* титульная часть (год и «N выбрано») */
  .v-date-picker-title{
    background:#FFFFFF !important;
    padding:24px 24px 12px !important;
  }
  .v-date-picker-title__year{
    font:400 18px/22px 'inherit';
    color:#757575 !important;
  }
  .v-date-picker-title__date,
  .v-date-picker-title__items-selected{
    font:700 36px/40px 'inherit';
    color:#2B2D33 !important;
  }

  /* шапка с месяцем + стрелками */
  .v-date-picker-header{
    background:#FFFFFF !important;
    color:#2B2D33 !important;
  }
  .v-date-picker-header .v-btn,
  .v-date-picker-header__value{
    color:#2B2D33 !important;
  }

  /* сами даты */
  .v-date-picker-table--date .v-btn:not(.v-btn--active){
    background:#FFFFFF !important;
    color:#2B2D33 !important;
  }
  .v-btn.v-btn--active{
    background:#4B5EFF !important;
    color:#2B2D33 !important;
  }
  .v-btn.v-btn--today:not(.v-btn--active){
    color:#4B5EFF !important;
  }

  /* поля времени и кнопка ОК */
  .time-field .v-input__slot{
    background:#FFFFFF !important;
    border:2px solid #4B5EFF !important;
    border-radius:8px !important;
    color:#2B2D33 !important;
    font-weight:400 !important;
  }
  .ok-btn{
    background:#4B5EFF !important;
    border:2px solid #4B5EFF !important;
    border-radius:8px !important;
    color:#ffffff !important;
    font-weight:600 !important;
  }

  /* защита от auto-white text Vuetify */
  .white--text{ color:#2B2D33 !important; }
}


/* ────────────────────  ФИЛЬТРЫ  ──────────────────── */
.filters {
  display:flex;
  align-items:center;
  justify-content:space-between;
  background:#EEF0FF;
  padding:22px 32px;
  border-radius:8px 8px 0 0;
}
@media (max-width: 800px) {
  .filters {
    flex-direction: column;
    align-items: stretch;  
    padding: 16px;
  }

  .filter {
    width: 100%;
    flex-wrap: wrap;
  }

  .filter_item {
    width: 100%;
    margin-right: 0;
    margin-bottom: 12px;
  }

  .filter_item.ml-4,
  .filter_item.ml-2 {
    margin-left: 0 !important;
  }

  /* все кнопки во всю ширину */
  .filter_item .v-btn,
  .apply-btn,
  .export-btn {
    width: 100%;
    justify-content: center;
  }

  /* поле даты во всю ширину */
  .input_range {
    min-width: 0;
    width: 100%;
  }
}

@media (max-width: 650px) {
   .apply-btn {
    width: 150px !important;
    height: 40px !important;
    border-radius: 6px !important;
    display: block !important;
    margin: 0 auto !important;
  }
   .filter_item.ml-4 {
    margin-left: 0 !important;
  }
   .export-btn {
    width: 150px !important;
    height: 40px !important;
    border-radius: 6px !important;
    display: block !important;
    margin: 0 auto !important;
  }
   .filter_item.ml-2 { 
    margin-left: 0 !important;
  }
}

@media (max-width: 480px) {
  ::v-deep .input_custom--base-names .v-input__slot {
    min-width: 0;
    max-width: none;
    width: 100%;
  }
}
.filter       { display:flex; align-items:flex-end; }
.filter_item  { display:flex; flex-direction:column; margin-right:16px; }

.wrap_titler  { display:flex; align-items:center; justify-content:space-between; margin-bottom:4px; }
.titler       { font-size:12px; line-height:14px; color:#757575; }
.clear        { cursor:pointer; display:flex; align-items:center; }

.rel          { position:relative; }
.abs          { position:absolute; top:13px; right:13px; }
.input_range  { min-width:250px; }

.only-successful-with-tip { display:flex; align-items:baseline; }
.tip-icon { margin-left:1px; cursor:pointer; position:relative; top:-22px; }

.apply-btn, .export-btn{
  background:#FFFFFF !important;
  border:1px solid #4B5EFF !important;
  border-radius:8px !important;
  color:#2B2D33 !important;
  font-weight:600;
  font-size:15px;
  line-height:120%;
  text-transform:none;
  padding:10px 20px;
}
.apply-btn--disabled, .export-btn--disabled{
  opacity:.5; pointer-events:none;
}
::v-deep(.fix-white-title) {
  /* заголовок с годом/«N выбрано» */
  .v-picker__title          { color:#2B2D33 !important; }
  /* внутри него Vuetify вставляет .white--text  →  перебиваем */
  .white--text               { color:#2B2D33 !important; }
}
::v-deep .picker-fix .white--text,
::v-deep .picker-fix .v-picker__title { color:#2B2D33 !important; }
::v-deep .time-field .v-input__slot {
  border: 2px solid #4B5EFF !important;   /* рамка вокруг всего поля */
  border-radius: 8px !important;
}

.wrap_titler.center{ justify-content:center; }
.wrap_titler.center .titler{ text-align:center; }

.range-row{ gap:12px; }
.range-row .v-text-field{ width:160px; }
.apply-timer {
  margin: 0 0 6px 16px;
  padding: 5px 10px;

  color: #4b5eff;
  background: rgba(75, 94, 255, 0.08);
  border: 1px solid rgba(75, 94, 255, 0.2);
  border-radius: 8px;

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  white-space: nowrap;

  box-shadow: 0 2px 6px rgba(75, 94, 255, 0.08);
}
::v-deep .export-group-dialog {
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(43, 45, 51, 0.22);
}

::v-deep .export-dialog-card {
  padding: 28px;
  border-radius: 18px !important;
  background: #ffffff;
}

::v-deep .export-dialog-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
  text-align: center;
}

::v-deep .export-dialog-head > div {
  width: 100%;
}

::v-deep .export-dialog-title,
::v-deep .export-dialog-subtitle {
  width: 100%;
  text-align: center;
}

::v-deep .export-dialog-icon {
  display: flex;
  flex: 0 0 52px;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  color: #4b5eff;
  background: #eef0ff;
  border-radius: 14px;
}

::v-deep .export-dialog-icon svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
  stroke: currentColor;
}

::v-deep .export-dialog-title {
  margin: 0;
  color: #2b2d33;
  font: 700 22px/1.25 Manrope, system-ui, sans-serif;
}

::v-deep .export-dialog-subtitle {
  margin: 5px 0 0;
  color: #757575;
  font: 400 14px/1.45 Manrope, system-ui, sans-serif;
}

::v-deep .export-options {
  margin: 0;
  padding: 0;
}

::v-deep .export-options .v-input--radio-group__input {
  gap: 12px;
}

::v-deep .export-option {
  box-sizing: border-box;
  width: 100%;
  margin: 0 !important;
  padding: 16px;
  background: #f8f9ff;
  border: 1px solid #e1e4f5;
  border-radius: 12px;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease;
}

::v-deep .export-option:hover {
  background: #f2f3ff;
  border-color: #b9c0ff;
}

::v-deep .export-option.v-item--active {
  background: #eef0ff;
  border-color: #4b5eff;
  box-shadow: 0 0 0 3px rgba(75, 94, 255, 0.1);
}

::v-deep .export-option .v-label {
  flex: 1;
  margin-left: 10px;
}

::v-deep .export-option-content {
  width: 100%;
}

::v-deep .export-option-title {
  color: #2b2d33;
  font: 600 15px/1.3 Manrope, system-ui, sans-serif;
}

::v-deep .export-option-description {
  margin-top: 4px;
  color: #757575;
  font: 400 13px/1.4 Manrope, system-ui, sans-serif;
}

::v-deep .export-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 28px;
}

::v-deep .export-cancel-btn,
::v-deep .export-confirm-btn {
  min-width: 120px !important;
  height: 42px !important;
  border-radius: 9px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

::v-deep .export-cancel-btn {
  color: #5d606b !important;
}

::v-deep .export-confirm-btn {
  color: #ffffff !important;
  background: #4b5eff !important;
}

::v-deep .export-confirm-btn:hover {
  background: #3f50e8 !important;
}

@media (max-width: 520px) {
  ::v-deep .export-dialog-card {
    padding: 22px 18px;
  }

  ::v-deep .export-dialog-actions {
    flex-direction: column-reverse;
  }

  ::v-deep .export-cancel-btn,
  ::v-deep .export-confirm-btn {
    width: 100%;
  }
}
</style>
